module.exports = __webpack_public_path__ + "static/media/preview.2f9deced.png";